import {
    postData,
    destroyData
} from '@/store/config/method'
const initialState = () => ({
    item: [],
    msg: 'Jaringan Bermasalah',
    status: 0
})
const state = initialState
const getters = {
    getItem: state => state.item,
    getMsg: state => state.msg,
    getStatus: state => state.status
}

const actions = {
    async submit({
        commit
    }, {url, data}) {
        try {
            var response = await postData(`/${url}`,data);
            commit('SET_ITEM', response.data);
        } catch (err) {
            commit('SET_FAILED_MSG', err.response)
        }
    },
    async destroy({
        commit
    }, url) {
        try {
            var response = await destroyData(`/${url}`);
            commit('SET_ITEM', response.data);
        } catch (err) {
            commit('SET_FAILED_MSG', err.response)
        }
    }
}

const mutations = {
    SET_FAILED(state) {
        state.msg = 'Jaringan Bermasalah'
        state.status = 0
    },
    SET_FAILED_MSG(state, error) {
        if(error.status == 400){
            state.msg = error.data.msg
            state.status = error.data.status
        }else{
            state.msg = 'Jaringan Bermasalah'
            state.status = 0
        }
    },
    SET_ITEM(state, response) {
        state.msg = response.msg
        state.status = response.status
        state.item = response.data
    },
    resetState (state) {
        const initial = initialState()
        Object.keys(initial).forEach(key => { state[key] = initial[key] })
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}